type Message = {
  message: string;
  icon: string;
};

const messages: Message[] = [
  { message: "C'est bon de vous revoir !", icon: '😌' },
  { message: 'Prêt pour ce challenge ?', icon: '💪🏼' },
  { message: "Comment allez-vous aujourd'hui ?", icon: '😇' },
  { message: 'Direction le dashboard', icon: '🚀' },
  { message: 'Bonjour, hello, buenos dias, hallo', icon: '👋🏼' },
  { message: "J'adore cette ambiance", icon: '😁' }
];

export const getGreetings = (): Message => {
  const index = Math.floor(Math.random() * messages.length);
  return messages[index];
};
